import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Shell from "@/components/Shell";
import { Loading } from "@/components/common";
import Landing from "@/pages/Landing";
import { Login, Register, ForgotPassword, ResetPassword } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Deposit from "@/pages/Deposit";
import Withdraw from "@/pages/Withdraw";
import Plans from "@/pages/Plans";
import Transactions from "@/pages/Transactions";
import Referrals from "@/pages/Referrals";
import AdminOverview from "@/pages/admin/Overview";
import AdminUsers from "@/pages/admin/Users";
import { AdminDeposits, AdminWithdrawals } from "@/pages/admin/Payments";
import AdminPlans from "@/pages/admin/Plans";
import AdminYoutubers from "@/pages/admin/Youtubers";
import AdminCommissions from "@/pages/admin/Commissions";
import AdminTransactions from "@/pages/admin/Transactions";
import AdminSettings from "@/pages/admin/Settings";
import AdminTickets from "@/pages/admin/Tickets";

function Guard({ admin, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#0B0E14]"><Loading /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (!admin && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<Guard><Shell /></Guard>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/deposit" element={<Deposit />} />
            <Route path="/withdraw" element={<Withdraw />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/referrals" element={<Referrals />} />
          </Route>
          <Route path="/admin" element={<Guard admin><Shell admin /></Guard>}>
            <Route index element={<AdminOverview />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="deposits" element={<AdminDeposits />} />
            <Route path="withdrawals" element={<AdminWithdrawals />} />
            <Route path="plans" element={<AdminPlans />} />
            <Route path="youtubers" element={<AdminYoutubers />} />
            <Route path="commissions" element={<AdminCommissions />} />
            <Route path="transactions" element={<AdminTransactions />} />
            <Route path="tickets" element={<AdminTickets />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthProvider>
  );
}
